import React, { type PropsWithChildren, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

type CollapseProps = PropsWithChildren<{ isOpen: boolean }>;

export const Collapse = ({ isOpen, children }: CollapseProps) => {
  const [height, setHeight] = useState(isOpen ? "auto" : 0);

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          style={{ overflow: "hidden", height }}
          initial={{ height: 0 }}
          animate={{ height: "auto" }}
          exit={{ height: 0 }}
          transition={{ duration: 0.3 }}
          onAnimationComplete={() => setHeight(isOpen ? "auto" : 0)}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
};
